// Deleting a route asks first (TX-US-0030): the list is everyone's. A route already gone answers
// 404, which is the outcome asked for - the list reloads and the dialog closes.

import { useState } from 'react';

import { deleteFleetRoute } from '../../api.js';
import Modal from '../../ui/Modal.jsx';

export default function DeleteRouteDialog({ route, onClose, onFleet, onGone }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onFleet(await deleteFleetRoute(route.route_id));
    } catch (err) {
      if (err.status === 404) {
        onGone();
      } else {
        setError(err.message);
        setBusy(false);
      }
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Delete “{route.name}”?</h3>
        <p className="hint">The route is removed for everyone. This cannot be undone.</p>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Deleting…' : 'Delete'}</button>
        </menu>
      </form>
    </Modal>
  );
}
